module.exports = BVConfigs.global;